module.exports = __webpack_public_path__ + "static/media/fvs_valve1_112.987cc750.jpg";